import { F } from '../utils/format';
import { ArrowUpRight, ArrowDownRight } from './icons';
export const DeltaBadge = ({ val, suffix = "", c }) => {
  if (!val || val === 0) return null;
  const pos = val > 0;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 2,
      fontSize: 11, fontWeight: 600, color: pos ? c.green : c.red, marginTop: 4,
    }}>
      {pos ? <ArrowUpRight size={10} /> : <ArrowDownRight size={10} />}
      {pos ? "+" : ""}{typeof val === "string" ? val : F(val)}{suffix}
    </span>
  );
};
